import { ReactNode, FunctionComponent, useState } from "react";
import { ButtonVariant } from "react-bootstrap/esm/types";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal'

type Props = {
    title: string
    message: string;
    onConfirm?: () => void;
    onCancel?: () => void;
    size?: 'sm' | 'lg';
    varient?: ButtonVariant;
    children?: ReactNode;
}

export const ConfirmButton: FunctionComponent<Props> = ({ title, message, onConfirm, onCancel, varient, size, children }) => {
    const [ show, setShow ] = useState(false);

    const showModal = () => {
        setShow(true)
    }

    const handleClose = () => {
        onCancel?.();
        setShow(false);
    }

    const handleConfirm = () => {
        onConfirm?.();
        setShow(false);
    }

    return (
        <>
            <Button variant={varient} size={size} onClick={showModal}>
                {children}
            </Button>
    
            <Modal show={show} onHide={handleClose}>
                <Modal.Header>
                    <Modal.Title>{title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{message}</Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-secondary" onClick={handleClose} size="sm">
                        Cancel
                    </Button>
                    <Button variant="outline-primary" onClick={handleConfirm} size="sm">
                        Ok
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}